import self from "../img/self.png"
import mock1 from "../img/mock1.png"
import mock2 from "../img/mock2.png"
import mock3 from "../img/mock3.png"
import mock4 from "../img/mock4.png"
import mock5 from "../img/mock5.png"
import mock6 from "../img/mock6.png"

/* Hi there! Thanks for checking out my portfolio template. Be sure to read the comments to get a better understanding of
how to make this template work best for you! */

export let colors = ["rgb(0,255,164)", "rgb(166,104,255)"];
/*
I highly recommend using a gradient generator like https://gradientgenerator.paytonpierce.dev/ to generate a pair of colors that you like.
These colors will be used to style your name on the homepage, the background of your picture, and some other accents throughout
the site.
 */


/*
So let's get started! Some of the info below is pretty self-explanatory, like 'firstName' and 'bio'. I'll try to explain anything
that might not be obvious right off the bat :) I recommend looking at the template example live using "npm start" to get an idea
of what each of the values mean.
 */

export const info = {
    firstName: "Phakpoom",
    lastName: "Sompot",
    initials: "js", // the example uses first and last, but feel free to use three or more if you like.
    position: "a Full Stack Developer.and IT Support.",
    selfPortrait: self, // don't change this unless you want to name your self-portrait in the "img" folder something else!
    gradient: `-webkit-linear-gradient(135deg, ${colors})`, // don't change this either
    baseColor: colors[0],
    miniBio: [ // these are just some "tidbits" about yourself. You can look at mine https://paytonjewell.github.io/#/ for an example if you'd like
        {
            emoji: '☕',
            text: 'fueled by Cacao'
        },
        {
            emoji: '🌎',
            text: 'based in Thamuang,Kanchaburi,Thailand'
        },
        {
            emoji: "💼",
            text: "Softwere Engineer"
        },
        {
            emoji: "📧",
            text: "lowquality1997@gmail.com"
        },
        {
            emoji: "📞",
            text: "097-0096465"
        }
    ],
    socials: [
        {
            link: "https://www.facebook.com/phakpoom.sompot",
            icon: 'fa fa-facebook',
            label: 'facebook'
        },
        {
            link: "https://line.me/ti/p/JCkNcWkB-m",
            icon: 'fa fa-phone',
            label: 'phone'
        },
    {
            link: "https://github.com/phakmcfc1234567",
            icon: "fa fa-github",
            label: 'github'
        }
// Feel free to remove any of these that you don't have. I'll write an FAQ on how to add new ones later, let me know if you have a request for an icon!
// Just change the links so that they lead to your social profiles.

    ],
    bio: "Hello! I'm Phakpoom. I'm a Softwere Engineer.I would like to apply for a job as a programmer in order to apply my knowledge, skills, and experience to contribute to the growth of the organization and company. I am also committed to continuously developing myself to keep up with future technologies. You should hire me!",
    skills:
        {
            Font_end:['- javascript','- html5', '- css'],
            Back_end:['- PHP','- nodejs', '- C#', '- C++', '- JAVA'],
            Framework:['- Bootstrap','- React', '- Laravel', '- VueJs','- jQuery','- ASP.NET'],
            Database:['- SQL','- Mysql', '- Firebase', '- Oracle'],
            Abilities:['- Service to take care of all kinds of IT equipment','- Can drive a car Have a personal car drivers license', '- Can communicate English enough', '- Have basic iot devices']
        }
    ,
    hobbies: [
        {
            label: 'Coding',
            emoji: '📖'
        },
        {
            label: 'Game',
            emoji: '🎲'
        },
        {
            label: 'movies',
            emoji: '🎥'
        },
        {
            label: 'Travel',
            emoji: '🌍'
        }
// Same as above, change the emojis to match / relate to your hobbies or interests.
// You can also remove the emojis if you'd like, I just think they look cute :P
    ],
    portfolio: [ // This is where your portfolio projects will be detailed
        {
            title: "Sasanan parcel delivery system MVC PHP",
            live: "http://192.168.1.219/transport/view/login.php", //this should be a link to the live version of your project, think github pages, netlify, heroku, etc. Or your own domain, if you have it.
            source: "https://github.com/phakmcfc1234567/sasanantransport.git", // this should be a link to the **repository** of the project, where the code is hosted.
            image: mock1
        },
        {
            title: "Warehouse system MVC PHP",
            live: "http://192.168.1.219/theinventory/dashboard/conf/login.php",
            source: "https://github.com/phakmcfc1234567/theinventory.git",
            image: mock2
        },
        {
            title: "System to notify time to work and leave work and notify duty MVC PHP",
            live: "http://192.168.1.219/workio/index.php",
            source: "https://github.com/phakmcfc1234567/workio.git",
            image: mock3
        },
        {
            title: "Dental room booking system MVC PHP",
            live: "http://192.168.1.219/cinictooth/model/signin",
            source: "https://github.com/phakmcfc1234567/cinictooth.git",
            image: mock4
        },
        {
            title: "Royal Irrigation Office website 13, plan section",
            live: "http://irrigation.rid.go.th/rid13/groups/practice/index.html",
           // source: "https://github.com/paytonjewell",
            image: mock5
        },
        {
            title: "Portfolio React",
            live: "http://irrigation.rid.go.th/rid13/groups/practice/index.html",
            source: "gh repo clone phakmcfc1234567/React-native-Portforio-Phakpoom",
            image: mock6
        }
    ]
}